import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 41 39",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M35.8035 27.0693C35.2213 26.4527 34.4799 26.0324 33.6726 25.8614L28.6944 24.8069C25.9664 24.2291 23.1344 24.6308 20.6461 25.9485L19.9844 26.2989C17.4961 27.6166 14.664 28.0183 11.9361 27.4405L7.90826 26.5873C6.54104 26.2977 5.12762 26.7509 4.14171 27.7951M11.975 1.83203H28.6555L26.5704 4.04036V15.4609C26.5704 16.6323 27.0098 17.7557 27.7918 18.584L38.2171 29.6257C40.8442 32.408 38.9836 37.1654 35.2684 37.1654H5.36207C1.64689 37.1654 -0.213676 32.408 2.41335 29.6256L12.8387 18.584C13.6207 17.7557 14.0601 16.6323 14.0601 15.4609V4.04036L11.975 1.83203Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }